import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useClub } from "../contexts/ClubContext";
import { atLeast, roleLabel, ROLES } from "../lib/roles";
import { BF, FF } from "../lib/constants";
import Modal from "./Modal";

var inputStyle = { width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid #ccc", fontSize: 14, outline: "none", marginBottom: 10, fontFamily: FF, boxSizing: "border-box" };

export function ChangePasswordModal({ onClose }) {
  var { changePassword } = useAuth();
  var [cur, setCur] = useState("");
  var [pw1, setPw1] = useState("");
  var [pw2, setPw2] = useState("");
  var [err, setErr] = useState("");
  var [busy, setBusy] = useState(false);
  var [done, setDone] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setErr("");
    if (pw1.length < 8) { setErr("Kies een wachtwoord van minimaal 8 tekens."); return; }
    if (pw1 !== pw2) { setErr("De twee nieuwe wachtwoorden zijn niet hetzelfde."); return; }
    setBusy(true);
    try {
      await changePassword(cur, pw1);
      setDone(true);
    } catch (e2) {
      console.error(e2);
      if (e2.code === "auth/wrong-password" || e2.code === "auth/invalid-credential") setErr("Je huidige wachtwoord klopt niet.");
      else if (e2.code === "auth/weak-password") setErr("Dit wachtwoord is te zwak.");
      else if (e2.code === "auth/too-many-requests") setErr("Te veel pogingen. Probeer het over een paar minuten opnieuw.");
      else setErr("Wijzigen mislukt (" + (e2.code || e2.message) + ").");
    }
    setBusy(false);
  }

  return (
    <Modal onClose={onClose}>
      <h3 style={{ fontFamily: BF, fontSize: 18, marginBottom: 14, color: "#1C1B19", fontWeight: 800 }}>Wachtwoord wijzigen</h3>
      {done ? (
        <div>
          <p style={{ fontSize: 13, color: "#38A169", marginBottom: 14 }}>Je wachtwoord is gewijzigd ✓</p>
          <button onClick={onClose} style={{ width: "100%", padding: 10, borderRadius: 8, background: "#1A2744", color: "#fff", border: "none", cursor: "pointer", fontSize: 14, fontWeight: 700 }}>Sluiten</button>
        </div>
      ) : (
        <form onSubmit={submit}>
          <input type="password" autoComplete="current-password" value={cur} onChange={function (e) { setCur(e.target.value); }} placeholder="Huidig wachtwoord" required autoFocus style={inputStyle} />
          <input type="password" autoComplete="new-password" value={pw1} onChange={function (e) { setPw1(e.target.value); }} placeholder="Nieuw wachtwoord (min. 8 tekens)" required style={inputStyle} />
          <input type="password" autoComplete="new-password" value={pw2} onChange={function (e) { setPw2(e.target.value); }} placeholder="Nieuw wachtwoord herhalen" required style={inputStyle} />
          {err && <p style={{ color: "#E53E3E", fontSize: 12, marginBottom: 8 }}>{err}</p>}
          <button type="submit" disabled={busy} style={{ width: "100%", padding: 10, borderRadius: 8, background: "#1A2744", color: "#fff", border: "none", cursor: busy ? "default" : "pointer", fontSize: 14, fontWeight: 700, opacity: busy ? .7 : 1 }}>{busy ? "Bezig..." : "Opslaan"}</button>
        </form>
      )}
    </Modal>
  );
}

export function RolesModal({ onClose }) {
  return (
    <Modal onClose={onClose}>
      <h3 style={{ fontFamily: BF, fontSize: 18, marginBottom: 14, color: "#1C1B19", fontWeight: 800 }}>Rollen</h3>
      <RolesList />
      <button onClick={onClose} style={{ width: "100%", marginTop: 14, padding: 10, borderRadius: 8, background: "#1A2744", color: "#fff", border: "none", cursor: "pointer", fontSize: 14, fontWeight: 700 }}>Sluiten</button>
    </Modal>
  );
}

function TennisBall({ on }) {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" style={{ opacity: on ? 1 : .25, filter: on ? "none" : "grayscale(1)", flexShrink: 0 }}>
      <circle cx="12" cy="12" r="11" fill="#C6DC3A" stroke="#A9BE24" strokeWidth="1" />
      <path d="M4.5 4.5 C9 8.5 9 15.5 4.5 19.5" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M19.5 4.5 C15 8.5 15 15.5 19.5 19.5" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

// Uitleg van de rollen als "ladder": 1 t/m 4 tennisballen, en elke rol bouwt voort op
// de rol erboven. Ook gebruikt op het accountsbeheer-scherm.
export function RolesList() {
  return (
    <div style={{ fontFamily: FF }}>
      {ROLES.map(function (r, i) {
        return (
          <div key={r.key} style={{ display: "flex", gap: 14, padding: "11px 0", borderBottom: i < ROLES.length - 1 ? "1px solid #eee" : "none" }}>
            <div style={{ display: "flex", gap: 2, width: 70, flexShrink: 0, paddingTop: 2 }}>
              {ROLES.map(function (x, j) { return <TennisBall key={x.key} on={j <= i} />; })}
            </div>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: 14, fontWeight: 700, color: "#1C1B19" }}>{r.label}</div>
              <div style={{ fontSize: 12, color: "#777", lineHeight: 1.5, marginTop: 1 }}>
                {i > 0 && <span style={{ color: "#aaa" }}>{"Alles van " + ROLES[i - 1].label.toLowerCase() + ", plus: "}</span>}
                {r.desc}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

function MenuItem({ onClick, children, danger }) {
  return (
    <button onClick={onClick} style={{ display: "block", width: "100%", textAlign: "left", background: "none", border: "none", padding: "10px 16px", fontSize: 13, fontFamily: FF, color: danger ? "#E53E3E" : "#1A2744", cursor: "pointer", fontWeight: 600 }}
      onMouseEnter={function (e) { e.currentTarget.style.background = "#F5F3EE"; }}
      onMouseLeave={function (e) { e.currentTarget.style.background = "none"; }}>
      {children}
    </button>
  );
}

// Accountmenu linksboven op het beginscherm (rechtsboven is de publiceer-knop).
export default function AccountMenu({ viewOnly, setViewOnly, onOpenAccounts, onOpenPlanning, compact }) {
  var { profile, logout } = useAuth();
  var { club } = useClub();
  var navigate = useNavigate();
  var [open, setOpen] = useState(false);
  var [pwModal, setPwModal] = useState(false);
  var [rolesModal, setRolesModal] = useState(false);
  var ref = useRef(null);

  useEffect(function () {
    if (!open) return;
    function onDoc(e) { if (ref.current && !ref.current.contains(e.target)) setOpen(false); }
    document.addEventListener("mousedown", onDoc);
    document.addEventListener("touchstart", onDoc);
    return function () {
      document.removeEventListener("mousedown", onDoc);
      document.removeEventListener("touchstart", onDoc);
    };
  }, [open]);

  if (!profile) return null;
  var display = profile.name || profile.email;
  var initial = (display || "?").trim().charAt(0).toUpperCase();
  // Bekijkmodus is nuttig voor iedereen die iets kan bewerken (vanaf hoofdtrainer:
  // extra oefeningen).
  var canToggleView = atLeast(profile, "hoofdtrainer");
  var isManager = atLeast(profile, "hoofdtrainer");

  return (
    <>
    <div ref={ref} style={{ position: "relative", zIndex: 60, fontFamily: FF }}>
      <button onClick={function () { setOpen(!open); }} style={{ display: "flex", alignItems: "center", gap: 8, background: "#fff", border: "1px solid #E2DED5", borderRadius: 20, padding: compact ? "4px 8px 4px 4px" : "4px 12px 4px 4px", height: 36, cursor: "pointer" }}>
        <span style={{ width: 26, height: 26, borderRadius: "50%", background: "#1A2744", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, fontWeight: 700 }}>{initial}</span>
        {!compact && <span style={{ fontSize: 12, color: "#1C1B19", fontWeight: 700, maxWidth: 140, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{profile.name || "Account"}</span>}
        {viewOnly && <span title="Bekijkmodus staat aan" style={{ fontSize: 12 }}>👁</span>}
        <span style={{ fontSize: 10, color: "#999" }}>▾</span>
      </button>
      {open && (
        <div style={{ position: "absolute", right: 0, top: "100%", marginTop: 6, background: "#fff", borderRadius: 12, boxShadow: "0 10px 40px rgba(0,0,0,.15)", minWidth: 240, overflow: "hidden", border: "1px solid #eee" }}>
          <div style={{ padding: "12px 16px", borderBottom: "1px solid #eee" }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: "#1C1B19", overflow: "hidden", textOverflow: "ellipsis" }}>{profile.name || profile.email}</div>
            {profile.name && <div style={{ fontSize: 11, color: "#999", overflow: "hidden", textOverflow: "ellipsis" }}>{profile.email}</div>}
            <div style={{ display: "flex", gap: 6, marginTop: 6, flexWrap: "wrap" }}>
              <span style={{ fontSize: 10, fontWeight: 700, textTransform: "uppercase", padding: "2px 8px", borderRadius: 4, background: "#1A2744", color: "#fff" }}>{roleLabel(profile.role)}</span>
              {club && <span style={{ fontSize: 10, fontWeight: 700, textTransform: "uppercase", padding: "2px 8px", borderRadius: 4, background: "#F5F3EE", color: "#555" }}>{club.name || club.slug}</span>}
            </div>
          </div>
          {atLeast(profile, "creator") && <MenuItem onClick={function () { setOpen(false); navigate("/beheer"); }}>⚙️ Beheer</MenuItem>}
          {isManager && <MenuItem onClick={function () { setOpen(false); onOpenAccounts(); }}>👥 Accounts beheren</MenuItem>}
          {onOpenPlanning && <MenuItem onClick={function () { setOpen(false); onOpenPlanning(); }}>📅 Seizoensplanning</MenuItem>}
          {canToggleView && <MenuItem onClick={function () { setViewOnly(!viewOnly); setOpen(false); }}>{viewOnly ? "✎ Bewerkmodus aanzetten" : "👁 Bekijkmodus aanzetten"}</MenuItem>}
          <MenuItem onClick={function () { setOpen(false); setPwModal(true); }}>🔑 Wachtwoord wijzigen</MenuItem>
          <MenuItem onClick={function () { setOpen(false); setRolesModal(true); }}>ℹ️ Uitleg rollen</MenuItem>
          <div style={{ borderTop: "1px solid #eee" }} />
          <MenuItem danger onClick={function () { logout(); }}>Uitloggen</MenuItem>
        </div>
      )}
    </div>
    {pwModal && <ChangePasswordModal onClose={function () { setPwModal(false); }} />}
    {rolesModal && <RolesModal onClose={function () { setRolesModal(false); }} />}
    </>
  );
}
